import { types, ISimpleType } from 'mobx-state-tree'
import * as THREE from 'three'
import { fontNames, fontPaths, FontName } from 'src/constants/font'
import { ExtendedFont, IFont } from './types'

export const Font: IFont = types
  .model('Font', {
    name: types.refinement(types.identifier, identifier =>
      fontNames.includes(identifier as FontName)
    ) as ISimpleType<FontName>
  })
  .extend(self => {
    let loading = true
    let font: ExtendedFont
    let promise: Promise<ExtendedFont>
    return {
      actions: {
        load() {
          if (promise === undefined && font === undefined) {
            console.log('LOAD FONT')
            promise = new Promise<ExtendedFont>(resolve =>
              new THREE.FontLoader().load(fontPaths[self.name], fontData => {
                loading = false
                font = (fontData as unknown) as ExtendedFont
                resolve(font)
              })
            )
          }
        }
      },
      views: {
        instance() {
          if (loading) {
            return promise
          } else {
            return font
          }
        }
      }
    }
  })
  .actions(self => ({
    afterCreate() {
      self.load()
    },
    afterAttach() {
      self.load()
    }
  }))
